import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ActionTrackerRequestViewModel, SalesLoftRequestModel, ActionTrackerBuyerRequestViewModel, ActionTrackerMarkUnmarkSetRequestViewModel, ActionTrackerCommunityRequestViewModel, LeadStreamForDirectRfqViewModel, SupplierPublishProfileStatusViewModel } from '../../models/actionTrackerModel';

@Injectable()
export class ActionTrackerService {
  moduleUrl: string;
  constructor(private _dataService: DataService, private _httpClient: HttpClient) { }


  getActionTrackerList(actionTrackerRequestViewModel: ActionTrackerRequestViewModel): Observable<any> {
    this.moduleUrl = 'ActionTracker';
    return this._dataService.add(this.moduleUrl, actionTrackerRequestViewModel);
  }
  getSalesLoftGeneratePeopleHyperlink(salesLoftRequestModel: SalesLoftRequestModel): Observable<any> {
    this.moduleUrl = 'SalesLoftGeneratePeopleHyperlink';
    return this._dataService.add(this.moduleUrl, salesLoftRequestModel);
  }

  getActionTrackerBuyerList(actionTrackerBuyerRequestViewModel: ActionTrackerBuyerRequestViewModel): Observable<any> {
    this.moduleUrl = 'ActionTrackerBuyer';
    return this._dataService.add(this.moduleUrl, actionTrackerBuyerRequestViewModel);
  }

  getActionTrackerCommunityList(actionTrackerCommunityRequestViewModel: ActionTrackerCommunityRequestViewModel): Observable<any> {
    this.moduleUrl = 'ActionTrackerCommunity';
    return this._dataService.add(this.moduleUrl, actionTrackerCommunityRequestViewModel);
  }
  setActionTrackerBuyerSetActions(actionTrackerBuyerSetRequestViewModel:any): Observable<any> {
    this.moduleUrl = 'ActionTrackerBuyerSetActions';
    return this._dataService.add(this.moduleUrl, actionTrackerBuyerSetRequestViewModel);
  }

  actionTrackerBuyerMessageDrawerSetActions(contactId:number,loggedInId:number): Observable<any> {
    this.moduleUrl = 'ActionTrackerBuyerMessageDrawerSetActions?loggedInId=' + loggedInId+ '&contactId='+contactId;
    return this._dataService.add(this.moduleUrl, '');
  }


  actionTrackerSetMarkUnMark(actionTrackerMarkUnmarkSetRequestViewModel:ActionTrackerMarkUnmarkSetRequestViewModel): Observable<any> {
    this.moduleUrl = 'ActionTrackerSetMarkUnMark';
    return this._dataService.add(this.moduleUrl, actionTrackerMarkUnmarkSetRequestViewModel);
  }

  actionTrackerBuyerUntouchedDirectoryMessageCount(): Observable <any> {
    this.moduleUrl = 'ActionTrackerBuyerUntouchedDirectoryMessageCount';
    return this._dataService.getAll(this.moduleUrl, '');
  }
  actionTrackerManufacturerNewProfilePendingCount(sourcingAdvisorsId: number): Observable <any> {
    this.moduleUrl = 'ActionTrackerManufacturerPendingBadgeCount?SourcingAdvisorsId=';
    return this._dataService.getAll(this.moduleUrl, sourcingAdvisorsId); 
  }
  actionTrackerUntouchedDirectRfqCount(): Observable <any> {
    this.moduleUrl = 'ActionTrackerUntouchedDirectRfqCount';
    return this._dataService.getAll(this.moduleUrl, '');
  }

  setSimpleRFQLeadStream(leadStreamForDirectRfqViewModel:LeadStreamForDirectRfqViewModel): Observable<any> {
    this.moduleUrl = 'SimpleRFQLeadStream';
    return this._dataService.add(this.moduleUrl, leadStreamForDirectRfqViewModel);
  }
  setSupplierPublishProfileStatus(supplierPublishProfileStatusViewModel: SupplierPublishProfileStatusViewModel): Observable<any> {
    this.moduleUrl = 'SupplierPublishProfileStatus';
    return this._dataService.add(this.moduleUrl, supplierPublishProfileStatusViewModel);
  }
  setRatingReviewApproveDecline(approvedDeclineRequestModel:any): Observable<any> {
    this.moduleUrl = 'ActionTrackerCommunity/SetRatingReviewApproveDecline' ;
    return this._dataService.add(this.moduleUrl, approvedDeclineRequestModel);
  }
  setVideoStatus(data): Observable<any> {
    this.moduleUrl = 'Supplier/SetVideos';
    return this._dataService.add(this.moduleUrl, data);
  }

}




// WEBPACK FOOTER //
// ./src/app/core/services/action-tracker/action-tracker.service.ts